import React, { useState } from "react";
import axios from "axios";

const SetCategory = ({ platformUrl }) => {
    const [categoryId, setCategoryId] = useState("");
    const [dataSourceKeyName, setDataSourceKeyName] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!categoryId || !dataSourceKeyName) {
            setError("Category ID and data source key name are required.");
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (!token) {
            setError("Missing access token. Please log in.");
            return;
        }

        setError("");
        setMessage("");
        setLoading(true);

        try {
            // Fetch the data source key using the name
            const dataSourceResponse = await axios.get(
                `${platformUrl}/learn/api/public/v1/dataSources/externalId:${dataSourceKeyName}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            const dataSource = dataSourceResponse.data;

            if (!dataSource) {
                setMessage("Data source key name not found.");
                setLoading(false);
                return;
            }

            const dataSourceKey = dataSource.externalId;

            // Verify the category exists
            const categoryResponse = await axios.get(
                `${platformUrl}/learn/api/public/v1/catalog/categories/Course`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // Check if the API returned a results array
            if (!categoryResponse.data.results || categoryResponse.data.results.length === 0) {
                setMessage("No categories found in the API response.");
                setLoading(false);
                return;
            }

            // Find the category with the matching categoryId
            const matchingCategory = categoryResponse.data.results.find(
                (category) => category.categoryId === categoryId
            );

            if (!matchingCategory) {
                setMessage("Category ID not found.");
                setLoading(false);
                return;
            }

            // Fetch all courses with the specified data source key
            const coursesResponse = await axios.get(`${platformUrl}/learn/api/public/v1/courses`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { dataSourceId: dataSource.id },
            });

            const courses = coursesResponse.data.results;

            if (!courses || courses.length === 0) {
                setMessage("No courses found with the specified data source key.");
                setLoading(false);
                return;
            }

            // Associate the category with each course
            const associatePromises = courses.map((course) =>
                axios.put(
                    `${platformUrl}/learn/api/public/v1/catalog/categories/Course/${matchingCategory.id}/courses/${course.id}`,
                    {}, // Empty body for the PUT request if the API doesn't require a body
                    { headers: { Authorization: `Bearer ${token}` } }
                )
            );

            await Promise.all(associatePromises);

            setMessage("All matching courses successfully associated with the category.");
        } catch (err) {
            console.error("Error associating categories:", err);
            setError(err.response?.data?.message || "An error occurred while associating categories.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="set-category-container">
            <h1>Set Category for Filtered Courses</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="categoryId">Category ID:</label>
                    <input
                        id="categoryId"
                        type="text"
                        value={categoryId}
                        onChange={(e) => setCategoryId(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="dataSourceKeyName">Data Source Key Name:</label>
                    <input
                        id="dataSourceKeyName"
                        type="text"
                        value={dataSourceKeyName}
                        onChange={(e) => setDataSourceKeyName(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? "Updating..." : "Set Category"}
                </button>
            </form>

            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default SetCategory;
